export default ['en', 'pt', 'ur', 'es', 'in', 'pa', 'ne', 'ir', 'ro', 'ru', 'te', 'cn']
